var e=function(e){var r,t=e.mode,n=e.selectedDates.filter(Boolean);switch(t){case"multiple":return n.join(", ");case"range":return n.join(" - ");default:return null!==(r=n[0])&&void 0!==r?r:""}};export{e as getDateInputValue};
//# sourceMappingURL=DateInput.helpers.js.map
